import type { SVGProps } from 'react';
import * as React from 'react';

export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.36334 9.41058L9.27409 11.3213L9.27409 2.49984C9.27409 2.0396 9.64718 1.6665 10.1074 1.6665C10.5677 1.6665 10.9408 2.0396 10.9408 2.49984L10.9408 11.3213L12.8515 9.41058C13.1769 9.08514 13.7046 9.08514 14.03 9.41058C14.3554 9.73602 14.3554 10.2637 14.03 10.5891L10.6967 13.9224C10.3712 14.2479 9.8436 14.2479 9.51817 13.9224L6.18483 10.5891C5.8594 10.2637 5.8594 9.73602 6.18483 9.41058C6.51027 9.08515 7.03791 9.08514 7.36334 9.41058Z"
      fill="black"
    />
    <path
      d="M2.60742 12.4998C2.60742 12.0396 2.98052 11.6665 3.44075 11.6665C3.90099 11.6665 4.27409 12.0396 4.27409 12.4998V15.3675C4.27409 15.7635 4.54422 16.0825 4.89546 16.1498C8.49012 16.8387 11.7247 16.8387 15.3194 16.1498C15.6706 16.0825 15.9408 15.7635 15.9408 15.3675L15.9408 12.4998C15.9408 12.0396 16.3139 11.6665 16.7741 11.6665C17.2343 11.6665 17.6074 12.0396 17.6074 12.4998V15.3675C17.6074 16.5243 16.8069 17.5617 15.6331 17.7867C11.8312 18.5153 8.38367 18.5153 4.58175 17.7867C3.40792 17.5617 2.60742 16.5243 2.60742 15.3675V12.4998Z"
      fill="black"
    />
  </svg>
);
